import type { KeyboardEvent } from "react";
import { InputNumber, type InputNumberProps } from "antd";

const DIGIT_KEY = /^\d$/;

const ALLOWED_KEYS = new Set([
  "Backspace",
  "Delete",
  "Tab",
  "Escape",
  "Enter",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
]);

function parcelDigitsOnlyKeyDown(e: KeyboardEvent<HTMLInputElement>): void {
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (ALLOWED_KEYS.has(e.key)) return;
  if (!DIGIT_KEY.test(e.key)) {
    e.preventDefault();
  }
}

const parcelDigitsParser = (display?: string): number | string => {
  const digits = (display ?? "").replace(/\D/g, "");
  return digits === "" ? "" : Number(digits);
};

const parcelDigitsFormatter = (value?: string | number): string => {
  if (value == null || value === "") return "";
  return String(value).replace(/\D/g, "");
};

/** InputNumber ในฟอร์มส่งพัสดุ — กรอก/วางได้เฉพาะตัวเลข */
export default function ParcelDigitsInput({
  className,
  onKeyDown,
  parser,
  formatter,
  inputMode,
  ...props
}: InputNumberProps) {
  const mergedClassName = ["parcel-field-number", className].filter(Boolean).join(" ");

  return (
    // @ts-expect-error react-i18next ReactNode กับ antd InputNumber children ไม่ตรงกันในโปรเจกต์นี้
    <InputNumber
      className={mergedClassName}
      parser={parser ?? parcelDigitsParser}
      formatter={formatter ?? parcelDigitsFormatter}
      inputMode={inputMode ?? "numeric"}
      onKeyDown={(e) => {
        parcelDigitsOnlyKeyDown(e);
        onKeyDown?.(e);
      }}
      {...props}
    />
  );
}
